import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const CancellationReasonsPage = lazy(() => import('./CancellationReasonsPage'));

const CancellationReasonsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.LicenseeAdmin,
  routes: [
    {
      path: 'cancellation-reasons',
      element: <CancellationReasonsPage />,
    },
  ],
};

export default CancellationReasonsConfig;
